import { render, staticRenderFns } from "./add-bill.vue?vue&type=template&id=23f8edab&scoped=true&"
import script from "./add-bill.vue?vue&type=script&lang=js&"
export * from "./add-bill.vue?vue&type=script&lang=js&"
import style0 from "./add-bill.vue?vue&type=style&index=0&id=23f8edab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f8edab",
  null
  
)

export default component.exports